import React, { Dispatch, SetStateAction } from 'react'
import { Memoized } from './dependencies'

type UseStateReturnType<S> = [S, Memoized<Dispatch<SetStateAction<S>>>]

export function useState<S>(initialState: S | (() => S)): UseStateReturnType<S>

export function useState<S = undefined>(): UseStateReturnType<S | undefined>

export function useState<S = undefined>(
  initialState?: S | (() => S),
): UseStateReturnType<S | undefined> {
  // eslint-disable-next-line no-restricted-properties
  return React.useState(initialState) as UseStateReturnType<S | undefined>
}
